import { Outlet } from 'react-router-dom';

/** Default page container with max width. */
export function DefaultPageLayout() {
  return (
    <div className="mx-auto w-full max-w-6xl">
      <Outlet />
    </div>
  );
}
